import { withTranslation } from '@application/i18n/with_translation';
import { Button, DialogModal } from '@cellula/react';

interface SexExplanationDialogProps {
	isOpen: boolean;
	onClose(): void;
}

export function SexExplanationDialog({ isOpen, onClose }: SexExplanationDialogProps) {
	return (
		<DialogModal.Root open={isOpen} closeable={false} onOpenChange={(open) => !open && onClose()}>
			<DialogModal.Title>{withTranslation('View.CreateNewMessage.InformationGathering.SexAssignedAtBirth.Title')}</DialogModal.Title>
			<DialogModal.Content>
				{withTranslation('View.CreateNewMessage.InformationGathering.SexAssignedAtBirth.Description')}
			</DialogModal.Content>
			<DialogModal.Footer>
				<DialogModal.Close asChild>
					<Button variant='primary' size='large'>
						{withTranslation('Generic.Continue')}
					</Button>
				</DialogModal.Close>
			</DialogModal.Footer>
		</DialogModal.Root>
	);
}
